import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import style from "./SpeedometerChart.module.scss";
import bronzeIcon from "../../components/Icons/bronzeIcon.svg";
import silverIcon from "../../components/Icons/silverIcon.svg";
import goldIcon from "../../components/Icons/goldIcon.svg";

const SpeedoMeterChart = ({
  currentSpeed,
  totalSpeed,
  height,
  width,
  type,
}: any) => {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setAnimation(true);
    }, 500);
    return () => window.clearTimeout(timer);
  }, []);

  const safeTotalSpeed = totalSpeed && totalSpeed > 0 ? totalSpeed : 200;
  const safeCurrentSpeed = Number.isFinite(currentSpeed)
    ? Math.max(0, Math.min(currentSpeed, safeTotalSpeed))
    : 0;
  const degree = animation ? (safeCurrentSpeed / safeTotalSpeed) * 180 - 90 : -90;

  const getJobStatusLabel = (speedValue: number) => {
    if (speedValue >= 180) return "Succeeded";
    if (speedValue >= 140) return "Running";
    if (speedValue >= 100) return "Failed";
    if (speedValue >= 60) return "Initiated";
    if (speedValue >= 20) return "Queued";
    return "No Status";
  };

  const data = {
    labels: ["Queued", "Initiated", "Failed", "Running", "Succeeded"],
    datasets: [
      {
        data: [100, 100, 100, 100, 100],
        backgroundColor: [
          "#6b7280",
          "#2563eb",
          "#ef4444",
          "#f59e0b",
          "#22c55e",
        ],
        hoverBackgroundColor: [
          "#6b7280",
          "#2563eb",
          "#ef4444",
          "#f59e0b",
          "#22c55e",
        ],
        borderWidth: 0,
        cutout: "72%",
        circumference: 180,
        rotation: 270,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    layout: {
      padding: 6,
    },
    animation: {
      duration: 1000,
    },
    maintainAspectRatio: false,
  };

  const needleStyle: any = {
    position: "absolute",
    width: "0.22rem",
    height: "42%",
    background: "linear-gradient(180deg, #0f172a 0%, #1e293b 100%)",
    borderRadius: "999px",
    top: "31%",
    left: "50%",
    boxShadow: "0 5px 14px rgba(15, 23, 42, 0.26)",
    transformOrigin: "bottom",
    transform: `rotate(${degree}deg) translate(-50%, 0)`,
    transition: "transform 1s ease-in-out",
  };

  return (
    <div className={style.speedometerRoot}>
      <Doughnut
        width={width}
        height={height}
        data={data}
        options={options}
        id="speedometer-chart"
      />
      <div style={needleStyle}></div>
      <div className={style.needleHub}></div>
      {type === "Job" && (
        <div className={style.textStyleJob}>
          <div className={style.statusTitle}>Current Job Status</div>
          <div className={style.statusValue}>{getJobStatusLabel(safeCurrentSpeed)}</div>
        </div>
      )}
      {type !== "Job" && (
        <div className={style.textStyleJtg}>
          {type === "Bronze" ? (
            <div className={style.layerLabel}>
              <img alt="addPlusicon" src={bronzeIcon} width={20} />
              Bronze
            </div>
          ) : type === "Silver" ? (
            <div className={style.layerLabel}>
              <img alt="addPlusicon" src={silverIcon} width={20} />
              Silver
            </div>
          ) : (
            <div className={style.layerLabel}>
              <img alt="addPlusicon" src={goldIcon} width={20} />
              Gold
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SpeedoMeterChart;
